/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceMakeModelId } from './DeviceMakeModelId';
import type { Reading } from './Reading';
import type { SerialNumber } from './SerialNumber';
import type { SizeItem } from './SizeItem';
import type { uuid } from './uuid';
import type { WidthItem } from './WidthItem';

/**
 * A component of a Modular Device
 */
export type MDComponent = {
	id?: uuid;
	existingComponent?: DeviceMakeModelId;
	serialNumber?: SerialNumber;
	reading?: Reading;
	sizeType?: MDComponent.sizeType;
	size?: SizeItem;
	width?: WidthItem;
	widthUnits?: MDComponent.widthUnits;
	changeComponent?: DeviceMakeModelId;
	/**
	 * The name of the device make. Only if changeComponent is not included (otherwise gets cleared). Clears value for changeComponent. Validation. Alphanumeric, spaces.
	 */
	changeMake?: string;
	/**
	 * The name of the device model. Only if changeComponent is not included (otherwise gets cleared). Clears value for changeComponent. Validation - Alphanumeric, hash, dash and spaces.
	 */
	changeModel?: string;
	changeSerialNumber?: SerialNumber;
	changeSizeType?: MDComponent.sizeType;
	changeSize?: SizeItem;
	changeWidth?: WidthItem;
	changeWidthUnits?: MDComponent.widthUnits;
	newComponent?: DeviceMakeModelId;
	/**
	 * The name of the device make. Only if changeComponent is type Other-Other. Validation. Alphanumeric, spaces.
	 */
	newMake?: string;
	/**
	 * The name of the device model. Only if changeComponent is type Other-Other. Validation - Alphanumeric, hash, dash and spaces.
	 */
	newModel?: string;
	newSerialNumber?: SerialNumber;
	newSizeType?: MDComponent.sizeType;
	newSize?: SizeItem;
	newWidth?: WidthItem;
	newWidthUnits?: MDComponent.widthUnits;
};
export namespace MDComponent {
	/**
	 * The type of device. Only if changeComponent is not included.
	 */
	export enum changeDeviceType {
		LOGGER = 'Logger',
		MODULAR_METER = 'Modular Meter',
		SC_METER = 'SC Meter',
		SENSOR = 'Sensor',
		TELEMETRY = 'Telemetry',
		WEIR_DISCHARGE = 'Weir Discharge',
		WL_STATION = 'WL Station',
	}
	/**
	 * The size type of the device
	 */
	export enum sizeType {
		FULL_PIPE = 'Full Pipe',
		PARTIALLY_FILLED_PIPE = 'Partially Filled Pipe',
		OPEN_CHANNEL = 'Open Channel',
	}
	/**
	 * The width units of the device
	 */
	export enum widthUnits {
		MILLIMETERS_MM_ = 'Millimeters (mm)',
		METRES_M_ = 'Metres (m)',
	}
}
